.list {
  margin: 0;
  padding-left: var(--tuna-spacing-3);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}
